import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  emptyStateTitle: {
    defaultValue: 'Não encontramos nichos para este contexto.',
    key: 'industry-category-niche-tab-emptyStateTitle',
  },
  emptyStateDescription: {
    defaultValue: 'Por enquanto este contexto não possui nichos relacionados a ele.',
    key: 'industry-category-niche-tab-emptyStateDescription',
  },
  createReport: {
    defaultValue: 'Criar report',
    key: 'industry-category-niche-tab-createReport',
  },
  emptyContexts: {
    defaultValue: 'Por enquanto este território não possui contextos relacionados a ele',
    key: 'industry-category-niche-tab-emptyContexts',
  },
})
